// @ts-strict-ignore
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getCampaignsDataCacheKey } from "./constants";
import type { GetCampaignsDataParams, GetCampaignsDataResponse } from "./types";

const formatTime = (type: string, startDate?: number, endDate?: number) => {
  if (startDate && endDate) {
    return {
      [type]: {
        start_date: startDate,
        end_date: endDate,
      },
    };
  }
};
export const getCampaignsData = reactQueryTableFetcherAdapter(
  getCampaignsDataCacheKey,
  async (
    signal,
    { appGroupId, query, groupby, limit = 20, start = 0, ...rest }: GetCampaignsDataParams
  ): Promise<GetCampaignsDataResponse> => {
    // Strip out time values since apiDataTable passes them in separately but API expects them
    // in a nested object
    const {
      last_edited_start_date,
      last_edited_end_date,
      created_start_date,
      created_end_date,
      sent_start_date,
      sent_end_date,
      ...strippedQuery
    } = query;
    return await fetch(
      getCampaignsDataCacheKey,
      "GET",
      {
        groupby,
        query: serializeQueryObjects(
          {
            ...strippedQuery,
            ...formatTime("edited", last_edited_start_date, last_edited_end_date),
            ...formatTime("created", created_start_date, created_end_date),
            ...formatTime("sent", sent_start_date, sent_end_date),
          },
          true
        ),
        limit,
        start,
        app_group_id: appGroupId,
        ...rest,
      },
      { signal }
    );
  }
);
